module.exports = __webpack_public_path__ + "img/emoji_panic.d947ffc4.svg";